
export default (window['SpeechRecognition'] || window['webkitSpeechRecognition'] || window['mozSpeechRecognition'] || window['msSpeechRecognition'])


// WEBPACK FOOTER //
// ./src/components/voice-control/utils/SpeechRecognitionApi.js